module.exports = __webpack_public_path__ + "static/media/banvit-logo-white.c5d57c5a.svg";